/**
 *  TutorialControls
 *
 *  Created by Legman on 08/06/2017.
 *
 */

import Common from "../Common";
import Tutorial from "./Tutorial";

import isMobile from "ismobilejs";

/**
 * @class
 * @extends Tutorial
 */
export default class TutorialControls extends Tutorial {
    constructor() {
        super();
    }

    show() {
        super.show(!isMobile.any ? translate("tutorial_controls") : translate("tutorial_controls_mobile"));

        this._panel.label.x = 110;

        const assets = Common.assets;
        const icon = new PIXI.Sprite(!isMobile.any ? assets.getTexture("ui_tut_keys") : assets.getTexture("ui_tut_hand"));
        icon.x = -220;
        icon.y = -8;
        icon.anchor = new PIXI.Point(0.5, 0.5);
        this._panel.addChild(icon);
    }
}